import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ReportModel } from '../classes/ReportModel'
import { RetornoConsultaModel } from '../classes/RetornoConsultaModel'
import { ReportViewModel } from '../classes/ReportViewModel'
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { ValidacaoDadosModel } from "../classes/ValidacaoDadosModel";
//import { LocalStorageService } from "angular-2-local-storage/dist";
import { Adal4Service } from "adal-angular4";
import { TokenService } from "./token.service";

@Injectable()
export class ReportsService {

  //TODO:add beaerer token later
  private headers;
  options;
  selectedReport: ReportModel;
  listaReports: ReportModel[];
  token: any;
  localStorage: Storage;
  constructor(private AdalService: Adal4Service, private _httpService: Http, private tokenService: TokenService) { 
    
    this.token = this.AdalService.userInfo.token;    
    this.headers = new Headers({'content-Type': 'application/json'});
    this.headers.append('authorization',`bearer ${this.token}`)
    
    //console.log("Headers: ", this.headers);
    //console.log(this.token);
  }

  getReportById(reportId: number): Promise<ReportModel> {
    let url = `/api/Report/${reportId}`;
    //this.tokenService.handleTokenExpiration();  
    return this._httpService.get(url, { headers: this.headers })
      .toPromise()
      .then(reports => reports.json() as ReportModel)
      .catch(this.handleError);
  }

  getReports(): Promise<ReportModel[]> {
    let url = "/getreports";
    //this.tokenService.handleTokenExpiration();
       return this._httpService.get(url, { headers: this.headers })
      .toPromise()
      .then(reports => reports.json())
      .catch(this.handleError);
  }

  

  addReport(reportVm: ReportViewModel): Promise<ReportModel> {
    let url = "/addreport";
    //this.tokenService.handleTokenExpiration();  
    return this._httpService
      .post(url, JSON.stringify(reportVm), { headers: this.headers })
      .toPromise()
      .then(report => {
        //console.log("report.json() from addReport: ", report.json());
        return report.json() as ReportModel
      })
      .catch(this.handleError);
      
  }



  updateReport(idReport: number, reportVm: ReportViewModel): Promise<string> {
    let url = `api/Report/${idReport}`;
    //this.tokenService.handleTokenExpiration();  
    return this._httpService
      .put(url, JSON.stringify(reportVm), { headers: this.headers })
      .toPromise()
      .then(res => res)
      .catch(this.handleError);

  }

  deleteReport(idReport: number) {
    let url = `api/Report/${idReport}`;
    //this.tokenService.handleTokenExpiration();  
    return this._httpService
      .delete(url, { headers: this.headers})
      .toPromise()
      .then(res => res)
      .catch(this.handleError);
  }

  setSelectedReport(reportSelected: ReportModel): void {
    this.selectedReport = reportSelected;
  }

  getSelectedReport(): ReportModel {
    return this.selectedReport;
  }

  testarQuery(dadosValidacao: ValidacaoDadosModel): Promise<RetornoConsultaModel> {
    let url = "/validarquery";
    let canProceed = true;
    // if (this.tokenService.handleTokenExpiration()){
    //   return null;
    // }  
  
    return this._httpService
    .post(url, JSON.stringify(dadosValidacao), { headers: this.headers })
    .toPromise()
    .then(dadosValidacao => dadosValidacao.json())
    .catch(this.handleError);
      
  }

  private handleError(error: any): Promise<any> {
    console.error('DEU ERRO!', error); // for demo purposes only
    // if(error.status == 401){
    //   error = "Você não está autorizado a executar esta operação.";
    // }
    //console.log("[Servico] Error.text()", error);
    return Promise.reject(error.message || error);
  }

  // handleError(error: any): Promise<any> {
  //   //console.error('Ocorreu um erro:', error.message);
  //   error = JSON.parse(error._body)
  //   return Promise.reject(error.Message || error);
  //   //return `Ocorreu um erro ao tentar inserir um relatório: ${error.text}`;
  // }
}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/reports.service.ts